<template
  src="./index.html"
  lang="html">
</template>
<style
  src="../../stylus/main.css"
  lang="css"
>
</style>
<script>

  import prvInput from "../../components/prv-input/prv-input.vue";
  import prvDropdown from "../../components/prv-dropdown/prv-dropdown.vue";
  import { ACL } from "../../security/acl";

  export default {
    components: {
      'prv-input': prvInput,
      'prv-dropdown': prvDropdown
    },
    data() {
      return {
        user:             null,
        username:         null,
        password:         null,
        userId:           null,
        userIdMty:        null,
        accessToken:      null,
        showRecovery:     false,
        badCredentials:   false,
        status:{
          sendEmail:      false
        },
        origin: 'NEC19',
      }
    },
    mounted() {
    },
    methods: {
      getUser() {

        if (!this.user) {
          return;
        }

        fetch('/api/v1/signin', {
          method: 'HEAD',
          headers: {
            'Accept': '*/*',
            'X-Create' : this.user
          },
          cors: 'no-cors',
          cache: 'no-cache',
        })
        .then(response => {

          switch(response.status) {

            case 204:
             this.username = response.headers.get('X-Create-Code');
            break;

            case 400:
            break;
          }
        })
        .catch();
      },
      login(){

        fetch('/api/v1/signin', {
          method: 'POST',
          headers: {
            'Accept': '*/*',
            'X-Grant-Type': 'password',
            'X-Time-Zone': (Intl && Intl.DateTimeFormat() && Intl.DateTimeFormat().resolvedOptions().timeZone),
            'Content-Type': 'application/json',
            'X-origin': this.origin
          },
          cors: 'no-cors',
          cache: 'no-cache',
          body: JSON.stringify({
            d1: this.username,
            d2: this.password
          })
        })
        .then(response => {
          console.log(response)
          switch(response.status) {

            case 201:
              localStorage.setItem("X_origin", JSON.stringify(this.origin));
              location.replace(ACL.getAuthorizedPath(response));
            break;

            case 400:
            break;

            case 401:
            case 403:
              this.badCredentials = true;

              this.getUser();
            break;

            case 406:
            case 422:
            break;

            default:

            break;

          }
        })
      },
      back() {

        this.password       = null;
        this.user           = null;
        this.username       = null;
        this.badCredentials = null;
        this.loggedInMty    = false
        localStorage.removeItem("X_origin")
      },
      recoverPassword() {

        fetch('/api/v1/signin', {
          method: 'HEAD',
          headers: {
            'accept': '*/*',
            'X-Reset': this.user
          },
          cors: 'no-cors',
          cache: 'no-cache',
        })
        .then(response => {

          if (response.status) {
            this.status.sendEmail = true;
          }

        })
        .catch();
      },
      goLanding() {
        location.replace(__ABOUT_HOST__);
      }
    }
  }
</script>
